import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el kit después de comprar?',
  a: 'El acceso es inmediato. Una vez aprobado el pago, recibís un correo electrónico automático con el enlace de descarga de los 6 tomos en formato digital PDF y los accesos a los bonos.'
}, {
  q: '¿Sirve si recién empiezo en el rubro o es solo para avanzados?',
  a: 'Sirve para ambos. Si estás empezando, te va a evitar cometer los errores costosos que arruinan a los profesionales novatos. Si ya tenés experiencia, va a optimizar tus tiempos para que dejes de perder noches trabajando en tareas administrativas.'
}, {
  q: '¿Necesito softwares caros o me alcanza con el celular?',
  a: 'Te alcanza con el celular o cualquier computadora. Todo está diseñado en formatos accesibles (PDF estructurados y enlaces a herramientas gratuitas como Canva) para que puedas usarlo parado en el medio de una obra.'
}, {
  q: '¿Los 3 bonos están incluidos en las dos ofertas?',
  a: 'Sí, tanto la opción Standard como la Pro Élite™ incluyen la Plantilla de Contrato, las Portadas en Canva y la Guía de Seguimiento por WhatsApp sin costo adicional.'
}, {
  q: '¿Sirve si me dedico solo a un rubro específico (ej. solo pintura o solo diseño)?',
  a: 'Totalmente. Aunque el enfoque principal es la remodelación de ambientes (cocinas, baños, livings), las estrategias de venta, el escudo legal, los desgloses de presupuestos y el seguimiento por WhatsApp aplican a cualquier servicio de arquitectura, construcción o diseño.'
}, {
  q: '¿Qué diferencia tiene esto con buscar consejos gratis en internet?',
  a: 'En internet encontrás listas de precios desactualizadas o videos sueltos de teoría. Este kit es un sistema de pasos validado específicamente para el mercado argentino actual, que une la ingeniería de costos con la psicología de ventas para cerrar contratos rápido.'
}, {
  q: '¿Por qué elegir el Pack Completo Pro Élite™ y no el estándar?',
  a: 'Porque el Pack Completo te da las herramientas de negocio para dejar de ser un autoempleado que corre detrás de la obra y empezar a gestionar tu actividad como una empresa rentable de remodelaciones, además de enseñarte a monetizar tus conocimientos online.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí, está respaldado por nuestra garantía de satisfacción de 7 días. Tu compra está 100% protegida.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-16 lg:py-24 bg-cyan-50" data-id="element-55">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-56">
        <div className="text-center mb-8 sm:mb-16" data-id="element-57">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-extrabold mb-2 sm:mb-4 text-[#2C5BAC]" data-id="element-58">
            DUDAS COMUNES — PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-3 sm:space-y-4" data-id="element-59">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg sm:rounded-xl overflow-hidden bg-white shadow-sm" data-id="element-60">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 py-4 sm:px-6 sm:py-5 text-left flex justify-between items-center focus:outline-none hover:bg-gray-50 transition-colors" data-id="element-61">
                <span className="font-bold text-sm sm:text-lg text-brand-dark pr-4 sm:pr-8" data-id="element-62">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 sm:w-6 sm:h-6 text-brand-accent flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-63" />
              </button>

              <AnimatePresence data-id="element-64">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-65">
                    <div className="px-4 pb-4 pt-1 sm:px-6 sm:pb-6 sm:pt-2 text-sm sm:text-base text-gray-600 leading-relaxed border-t border-gray-100" data-id="element-66">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}